import React, { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import api, { fmtError } from "@/lib/api";
import { toast } from "sonner";

const BLANK = { code: "", type: "percentage", value: 10, min_order_usd: 0, max_discount_usd: null, storefronts: ["jewelry", "men", "women"], per_customer_limit: 1, usage_limit: null, expiry: null, active: true };

export default function AdminDiscounts() {
  const [codes, setCodes] = useState([]);
  const [f, setF] = useState(BLANK);

  const load = () => api.get("/admin/discounts").then((r) => setCodes(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async () => {
    try { await api.post("/admin/discounts", { ...f, value: Number(f.value), min_order_usd: Number(f.min_order_usd) }); toast.success("Code created."); setF(BLANK); load(); }
    catch (e) { toast.error(fmtError(e.response?.data?.detail)); }
  };
  const del = async (id) => { await api.delete(`/admin/discounts/${id}`); load(); };
  const toggle = async (c) => { await api.put(`/admin/discounts/${c.id}`, { active: !c.active }); load(); };

  const sfToggle = (s) => setF({ ...f, storefronts: f.storefronts.includes(s) ? f.storefronts.filter((x) => x !== s) : [...f.storefronts, s] });
  const inp = "w-full h-10 px-3 border border-neutral-300 rounded text-sm";

  return (
    <div>
      <h1 className="font-serif text-3xl mb-6">Discount Codes</h1>
      <div className="grid lg:grid-cols-[1fr_1.3fr] gap-8">
        <div className="bg-white border border-neutral-200 rounded-lg p-6 h-fit">
          <h2 className="font-serif text-xl mb-4">Create Code</h2>
          <label className="text-xs uppercase text-neutral-500">Code</label>
          <input data-testid="discount-code" className={`${inp} mb-3 uppercase`} value={f.code} onChange={(e) => setF({ ...f, code: e.target.value })} placeholder="SAVE20" />
          <div className="grid grid-cols-2 gap-3 mb-3">
            <div><label className="text-xs uppercase text-neutral-500">Type</label><select className={inp} value={f.type} onChange={(e) => setF({ ...f, type: e.target.value })}><option value="percentage">Percentage</option><option value="fixed">Fixed Amount</option><option value="free_shipping">Free Shipping</option></select></div>
            <div><label className="text-xs uppercase text-neutral-500">Value</label><input data-testid="discount-value" type="number" className={inp} value={f.value} onChange={(e) => setF({ ...f, value: e.target.value })} disabled={f.type === "free_shipping"} /></div>
          </div>
          <div className="grid grid-cols-2 gap-3 mb-3">
            <div><label className="text-xs uppercase text-neutral-500">Min Order (USD)</label><input type="number" className={inp} value={f.min_order_usd} onChange={(e) => setF({ ...f, min_order_usd: e.target.value })} /></div>
            <div><label className="text-xs uppercase text-neutral-500">Per Customer Limit</label><input type="number" className={inp} value={f.per_customer_limit || ""} onChange={(e) => setF({ ...f, per_customer_limit: e.target.value ? Number(e.target.value) : null })} /></div>
          </div>
          <label className="text-xs uppercase text-neutral-500">Applies To</label>
          <div className="flex gap-4 my-2">
            {["jewelry", "men", "women"].map((s) => <label key={s} className="flex items-center gap-1.5 text-sm capitalize"><input type="checkbox" checked={f.storefronts.includes(s)} onChange={() => sfToggle(s)} />{s}</label>)}
          </div>
          <button data-testid="discount-create" onClick={create} className="mt-4 w-full bg-neutral-900 text-white h-10 rounded text-sm flex items-center justify-center gap-2"><Plus size={15} /> Create Code</button>
        </div>

        <div>
          {codes.length === 0 ? <div className="bg-white border border-neutral-200 rounded-lg p-12 text-center text-neutral-500">No discount codes yet.</div> : (
            <div className="space-y-3">
              {codes.map((c) => (
                <div key={c.id} data-testid={`discount-row-${c.code}`} className="bg-white border border-neutral-200 rounded-lg p-4 flex items-center justify-between">
                  <div>
                    <span className="font-mono font-semibold">{c.code}</span>
                    <span className="ml-3 text-sm text-neutral-500">{c.type === "percentage" ? `${c.value}% off` : c.type === "fixed" ? `$${c.value} off` : "Free shipping"}{c.min_order_usd ? ` · min $${c.min_order_usd}` : ""}</span>
                    <div className="text-xs text-neutral-400 mt-1">{(c.storefronts || []).join(", ")} · used {c.used || 0}×</div>
                  </div>
                  <div className="flex items-center gap-3">
                    <button onClick={() => toggle(c)} className={`text-xs px-3 py-1 rounded ${c.active ? "bg-green-100 text-green-700" : "bg-neutral-100 text-neutral-500"}`}>{c.active ? "Active" : "Inactive"}</button>
                    <button onClick={() => del(c.id)} className="text-red-500 p-1"><Trash2 size={15} /></button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
